import { useState, useEffect, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { TCustomer } from '../models/customer';

export const useCustomerInfo = () => {
  const { customer } = useContext(ExperienceContext);
  const [customerInfo, setCustomerInfo] = useState<TCustomer>(() => ({
    role: '',
    customerType: customer?.type?.toUpperCase() || '',
    svocID: '',
    userID: '',
  }));

  useEffect(() => {
    setCustomerInfo({
      role: window.THDCustomer?.default.role || '',
      customerType: window.THDCustomer?.default.customerType || '',
      svocID: window.THDCustomer?.default.svocID || '',
      userID: window.THDCustomer?.default.userID || '',
    });
  }, []);

  return customerInfo;
};
